import { Outlet } from "@tanstack/react-router"
import { Button } from "design-system/atoms/Button"
import { Plus } from "lucide-react"
import { useGenerateGmailAuthLinkQuery } from "modules/settings/hooks/gmail/useGenerateGmailAuthLinkQuery"
import { useTranslation } from "react-i18next"
import { SignatureBanner } from "../../channels/SignatureBanner"
import { GmailIntegrationsTable } from "./GmailIntegrationsTable"

export const GmailConfiguration = () => {
  const { t } = useTranslation()
  const { data, isPending } = useGenerateGmailAuthLinkQuery()

  return (
    <>
      <div className="flex flex-col gap-6">
        <SignatureBanner />
        <div className="flex flex-col gap-4">
          <div className="flex justify-end w-full">
            <a href={data?.url}>
              <Button disabled={isPending}>
                <Plus />
                {t("settings.integrations.gmail.table.addIntegration")}
              </Button>
            </a>
          </div>
          <GmailIntegrationsTable addIntegrationLink={data?.url} />
        </div>
      </div>
      <Outlet />
    </>
  )
}
